module.exports = __webpack_public_path__ + "static/media/English - Teaching - Prayer - translated by JL.ba58ac5a.txt";